import styled from 'styled-components'

const StyledFixedHeightContainer = styled.div`
  min-height: 33px;
  margin-bottom: 5px;
`

export default StyledFixedHeightContainer
